// src/context/LoadingContext.js
import React, { createContext, useState, useMemo, useCallback } from 'react';

export const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);

    const setLoadingMemoized = useCallback((value) => {
        setLoading(value);
    }, []);

    const value = useMemo(() => ({
        loading,
        setLoading: setLoadingMemoized
    }), [loading, setLoadingMemoized]);

    return (
        <LoadingContext.Provider value={value}>
            {children}
        </LoadingContext.Provider>
    );
};
